import request from "@/utils/request";

export default function agentGetAllUserListById(id) {
  return request({
    url: `/user/userManage/agentGetAllUserListById/${id}`,
  });
}
